export default __webpack_public_path__ + "static/media/icon-ui-parking.15063177.svg";